import React from 'react';
import { Truck, Clock, MapPin } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const DeliverySection = ({ language }) => {
  const content = {
    en: {
      title: 'Home Delivery',
      subtitle: 'Coming Soon!',
      description: 'We are excited to announce that our home delivery service will be launching soon. Stay tuned for doorstep convenience!',
      features: [
        { icon: Truck, text: 'Free Home Delivery' },
        { icon: Clock, text: 'Fast Service' },
        { icon: MapPin, text: 'Local Area Coverage' }
      ],
      notify: 'Contact us to get notified when delivery starts'
    },
    gu: {
      title: 'હોમ ડિલિવરી',
      subtitle: 'ટૂંક સમયમાં આવી રહ્યું છે!',
      description: 'અમે જાહેરાત કરતાં ખુશ છીએ કે અમારી હોમ ડિલિવરી સેવા ટૂંક સમયમાં શરૂ થશે. ઘરઆંગણે સુવિધા માટે જોડાયેલા રહો!',
      features: [
        { icon: Truck, text: 'મફત હોમ ડિલિવરી' },
        { icon: Clock, text: 'ઝડપી સેવા' },
        { icon: MapPin, text: 'સ્થાનિક વિસ્તાર કવરેજ' }
      ],
      notify: 'ડિલિવરી શરૂ થાય ત્યારે સૂચિત થવા માટે અમારો સંપર્ક કરો'
    }
  };

  const t = content[language];

  return (
    <section id="delivery" className="py-20 bg-gradient-to-br from-red-50 to-yellow-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <Card className="border-4 border-red-600 shadow-2xl overflow-hidden">
            <CardContent className="p-0">
              <div className="bg-red-600 text-white text-center py-8 px-6">
                <h2 className="text-4xl md:text-5xl font-bold mb-2">{t.title}</h2>
                <div className="inline-block bg-yellow-400 text-red-900 px-6 py-3 rounded-full text-2xl font-black mt-4 animate-pulse">
                  {t.subtitle}
                </div>
              </div>
              
              <div className="p-8 md:p-12 bg-white">
                <p className="text-xl text-gray-700 text-center mb-8 leading-relaxed">
                  {t.description}
                </p>
                
                <div className="grid md:grid-cols-3 gap-6 mb-8">
                  {t.features.map((feature, index) => {
                    const Icon = feature.icon;
                    return (
                      <div key={index} className="text-center">
                        <div className="bg-red-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                          <Icon className="h-10 w-10 text-red-600" />
                        </div>
                        <p className="font-semibold text-gray-900">{feature.text}</p>
                      </div>
                    );
                  })}
                </div>
                
                <div className="text-center">
                  <p className="text-gray-600 mb-4">{t.notify}</p>
                  <a 
                    href="https://wa.me/919924086184"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-green-500 hover:bg-green-600 text-white font-bold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
                  >
                    {language === 'en' ? 'WhatsApp Us' : 'WhatsApp પર સંપર્ક કરો'}
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};